import { Card, CardContent, CardHeader, Box, Typography, Divider } from '@mui/material';

import { fCurrency } from '../../utils/formatNumber';

interface TotalSummaryProps {
	total: number;
	subtotal: number;
	gst: number;
	discount?: number;
	discountLabel?: string;
}

export const TotalSummary = ({ total, subtotal, gst, discountLabel = 'Discount', discount = 0 }: TotalSummaryProps) => {
	return (
		<Card variant="outlined">
			<CardHeader title="Summary" sx={{ color: 'grey.600' }} />
			<CardContent>
				<Divider sx={{ mb: 2 }} />

				<Box display="flex" justifyContent="space-between" mb={1}>
					<Typography>Items Total:</Typography>
					<Typography>{fCurrency(subtotal)}</Typography>
				</Box>
				{discount !== 0 && (
					<Box display="flex" justifyContent="space-between" mb={1}>
						<Typography>{discountLabel}:</Typography>
						<Typography>{fCurrency(-discount)}</Typography>
					</Box>
				)}
				<Box display="flex" justifyContent="space-between" mb={1}>
					<Typography>GST(10%):</Typography>
					<Typography>{fCurrency(gst)}</Typography>
				</Box>
				<Divider sx={{ my: 2 }} />
				<Box display="flex" justifyContent="space-between">
					<Typography fontWeight="bold" variant="h5">
						Total
					</Typography>
					<Typography fontWeight="bold" variant="h5">
						{fCurrency(total)}
					</Typography>
				</Box>
			</CardContent>
		</Card>
	);
};
